<div #sidebar appSidebar *ngIf="dataService.logado" [class.c-sidebar-show]="sidebarAberta">
</div>

<div class="c-wrapper">

  <header class="c-header c-header-light c-header-fixed c-header-shadow" *ngIf="dataService.logado">

    <button matRipple class="mat-ripple c-header-toggler" type="button" 
            (click)="toggleSidebar()">
      <span class="c-header-toggler-icon"></span>
    </button>

    <div class="c-header-brand">
      <strong>Wowcorp Management</strong>
    </div>

    <ul class="c-header-nav ml-auto mr-3 d-flex flex-column text-right" style="padding-top: 8px;">
      <li class="c-header-nav-item">
        <strong>Bem Vindo {{dataService.usuarioLogado}}</strong>
      </li>
      <li class="c-header-nav-item">
        <strong>Acesso Expira em {{dataService.horaExpirarToken}}</strong>
      </li>
    </ul>

    <div class="c-header-nav mr-4">
      <button mat-button  (click)="sair()">
        <mat-icon>logout</mat-icon>
        
      </button>
    </div>

  </header>

  <div class="c-body">
    <router-outlet></router-outlet>
  </div>

  <div id="preloader">
    <div class="loader">
      <div id="status">&nbsp;</div>
      <div class="loading-animacao"></div>
      <span id="loadingText" class="title">Processando ...</span>
    </div>
  </div>

</div>
